module.exports = __webpack_public_path__ + "img/07.17f170ab.png";